import React from 'react';
import { Box, Flex, Input, Button, Badge, Image, Text, VStack } from '@chakra-ui/react';
import { ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';

export default function Component() {
    return (
        <Flex direction="column" w="full" border="1px" borderColor="gray.200" borderRadius="lg" overflow="hidden">
            <Flex w="full" alignItems="center" borderBottom="1px" borderColor="gray.200" h="10">
                <Box w="40" px="3.5">
                    <label htmlFor="search" className="sr-only">
                        Search
                    </label>
                    <Input id="search" placeholder="Search" borderColor="transparent" h="8" _placeholder={{ color: 'gray.500' }} />
                </Box>
                <Button h="8" w="8" m="1.5" p="0" borderColor="transparent" variant="outline" borderRadius="full">
                    <SearchIcon w="4" h="4" />
                    <span className="sr-only">Search</span>
                </Button>
                <Badge colorScheme="blue" ml="1.5" variant="outline">
                    Active
                </Badge>
            </Flex>
            <Flex w="full" alignItems="center" justifyContent="between" borderBottom="1px" borderColor="gray.200" h="10">
                <Flex w="full" alignItems="center" h="10" px="3" fontWeight="semibold">
                    <Text w="40">Logo</Text>
                    <Text w="40" cursor="pointer">Name</Text>
                    <Text w="20" cursor="pointer">Active</Text>
                    <Text w="40" cursor="pointer">Created</Text>
                    <Text w="40" cursor="pointer">Plan</Text>
                    <Text w="40" cursor="pointer">Contact</Text>
                    <Text w="40" cursor="pointer">Country</Text>
                    <Text w="40" cursor="pointer">City</Text>
                </Flex>
                <Button h="8" w="8" m="1.5" p="0" size="sm" variant="ghost">
                    <ChevronUpIcon w="4" h="4" />
                    <span className="sr-only">Sort ascending</span>
                </Button>
            </Flex>
            <VStack w="full" alignItems="center" justifyContent="center" gap="0.5" p="3" spacing="3" fontSize="sm">
                {/* Repeat this box for each row you have. Example for one row: */}
                <Flex w="full" alignItems="center" h="10" px="3">
                    <Flex w="40" alignItems="center" gap="2">
                        <Image borderRadius="full" boxSize="20px" src="/placeholder.svg" alt="Company logo" />
                        <Text>Acme Inc</Text>
                    </Flex>
                    <Text w="40">John Doe</Text>
                    <Text w="20">Yes</Text>
                    <Text w="40">2023-10-01</Text>
                    <Text w="40">Pro</Text>
                    <Text w="40">jane@example.com</Text>
                    <Text w="40">United States</Text>
                    <Text w="40">New York</Text>
                </Flex>
                {/* Add more boxes as needed */}
            </VStack>
            <Flex w="full" alignItems="center" justifyContent="end" h="8" px="3">
                <Text fontSize="xs" color="gray.500">Showing 1 to 5 of 5 entries</Text>
            </Flex>
        </Flex>
    );
}
